import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycLegalGuardianshipForDisabledOrSpecialNeedsChildrenPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-legal-guardianship-for-disabled-or-special-needs-children/']} />;
}
